"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var SiteReleaseTerminationUpload_1 = require("../../model/price-termination/SiteReleaseTerminationUpload");

var SiteReleaseTerminationUploadConverter_1 = require("./SiteReleaseTerminationUploadConverter");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationUploadConverterImpl =
/*#__PURE__*/
function (_SiteReleaseTerminati) {
  _inherits(SiteReleaseTerminationUploadConverterImpl, _SiteReleaseTerminati);

  function SiteReleaseTerminationUploadConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, SiteReleaseTerminationUploadConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationUploadConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseTerminationUploadConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        issued: conversions.fromDate(source.issued),
        progressId: conversions.toDocumentReferenceId(source.progressId),
        terminationId: conversions.toDocumentReferenceId(source.terminationId),
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SiteReleaseTerminationUpload_1.SiteReleaseTerminationUpload(conversions.documentToClassId(source), conversions.asObject(source, 'name', function (v) {
        return v;
      }), conversions.asObject(source, 'issued', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'progressId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'terminationId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SiteReleaseTerminationUploadConverterImpl;
}(SiteReleaseTerminationUploadConverter_1.SiteReleaseTerminationUploadConverter);

SiteReleaseTerminationUploadConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], SiteReleaseTerminationUploadConverterImpl);
exports.SiteReleaseTerminationUploadConverterImpl = SiteReleaseTerminationUploadConverterImpl;